import styled from "@rentiohq/web-theme";

export const ImagesContainer = styled.div`
  margin: 16px 16px 16px 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const StyledImage = styled.img`
  object-fit: contain;
  border-radius: 4px;
`;
